import React, { useEffect } from "react";
import {
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import Menu from "./menu";
import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material"; 

const TwoButtons = styled.div``;
const BuyButton = styled.button`
  cursor: pointer;
  padding: 7px 35px;
  border: none;
  box-shadow: ${(props) =>
    props.bs ? props.bs : "inset 0px 2px 5px 0px white"};
  font-weight: 600;
  font-size: 14px;
  border-radius: 20px;
  border: ${(props) => (props.brdrColor ? props.brdrColor : "1px solid #fff")};
  max-width: 100%;
  background-color: ${(props) => (props.bgColor ? props.bgColor : "#D4A204")};
`;
const Socials = styled.div`
  /* font-size:0px; */
  padding-top: 40px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 599px) {
    padding-bottom: 100px;
  }
`;
const Sociallinks = styled.a`
  cursor: pointer;
  margin-left: 10px;

  display: flex;
  align-items: center;
`;
const SocialText = styled.span`
  padding-left: 10px;
  font-weight: 600;
  @media screen and (max-width: 363px) {
    font-size: 10px;
  }
`;
const Text = styled.span`
  font-weight: 600;
  @media screen and (max-width: 599px) {
    text-transform: lowercase;
    display: none;
  }
`;
const CustomGrid = styled(Grid)`
  /* position: relative; */

  @media screen and (max-width: 899px) {
    text-align: center;
  }
`;
const ImageFloki = styled.div`
  position: absolute;
  right: 0px;
  top: -40px;
  @media screen and (max-width: 899px) {
    width: 50%;
    top: 75px;
  }
  @media screen and (max-width: 599px) {
    width: 50%;
  }
`;

const SocialImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 30px;
`

const MainImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 600px;
`

const Index = () => {
  return (
    <div>
      <Menu />
      <SectionWrapper pt="100px" id="explore" pb650px="10px">
        <Container maxWidth="xl">
          <Grid container>
            <Grid xs={12}>
              <SectionHeading>The people&apos;s cryptocurrency.</SectionHeading>
              <P mb="40px" mt="30px" maxWidth="40%">
                Floki Gold will become the gold standard of all memecoins by
                providing a 100% safe and decentralized token that is owned by
                the people, for the people — The one token to rule all
                memecoins!
              </P>
              <TwoButtons>
                <BuyButton brdrColor="none">Buy Now</BuyButton>
                &nbsp;&nbsp;&nbsp;
                <BuyButton bs="none" bgColor="transparent">
                  Live Chart
                </BuyButton>
              </TwoButtons>
              <SectionSmallHeading mt="60px">
                Contract Address: TBA
              </SectionSmallHeading>
              <Socials>
                <Text>Follow us:</Text>
                <Sociallinks href="https://twitter.com/Flokigoldd?t=zbjXk6LWRT4tmeiTyOu00A&s=35">
                  <SocialImage
                    src="/images/twitter.png" 
                  />

                  <SocialText>Twitter</SocialText>
                </Sociallinks>
                <Sociallinks href="https://t.me/flokigoldeth" target="_blank">
                  <SocialImage
                    src="/images/telegram.png" 
                  />
                  <SocialText>Telegram</SocialText>
                </Sociallinks>
                <Sociallinks
                  href="https://medium.com/@riseofcrypto/the-rise-of-floki-gold-2fad5934a8ac"
                  target="_blank"
                >
                  <SocialImage
                    src="/images/medium.png" 
                  />
                  <SocialText>Medium</SocialText>
                </Sociallinks>
              </Socials>
            </Grid>
            {/* <CustomGrid xs={12} md={6}> */}
            <ImageFloki>
              <MainImage
                src="/images/mainimage.png" 
              />
            </ImageFloki>
            {/* </CustomGrid> */}
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default Index;
